import {createRouter,createWebHashHistory} from 'vue-router'

const router = createRouter({
    history: createWebHashHistory('/pro/'),
    // history: createWebHashHistory(),
    // history: createWebHistory(),
    routes: [{
            name: 'home',
            path: '/',
            meta: { isLogin: true },
            // component: resolve => require(['../views/home/home'], resolve),
            component: () => require.ensure([], (require) => require('../views/home/home')),
            // component: () =>
            //     import ('../views/home/home'),
            children: [
                // 数据统计
                {
                    name: 'dashboard',
                    path: '/dashboard',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/dashboard/dash/dashboard'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/dashboard/dash/dashboard'))
                        // component: () =>
                        //     import ('../views/home/dashboard/dash/dashboard')
                },
                {
                    name: 'storedata',
                    path: '/storedata',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/dashboard/storedata/storedata'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/dashboard/storedata/storedata'))
                        // component: () =>
                        //     import ('../views/home/dashboard/storedata/storedata')
                },
                {
                    name: 'financedata',
                    path: '/financedata',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/dashboard/financedata/financedata'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/dashboard/financedata/financedata'))
                        // component: () =>
                        //     import ('../views/home/dashboard/financedata/financedata')
                },
                {
                    name: 'customerdata',
                    path: '/customerdata',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/dashboard/customerdata/customerdata'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/dashboard/customerdata/customerdata'))
                        // component: () =>
                        //     import ('../views/home/dashboard/customerdata/customerdata')
                },
                {
                    name: 'servicedata',
                    path: '/servicedata',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/dashboard/servicedata/servicedata'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/dashboard/servicedata/servicedata'))
                        // component: () =>
                        //     import ('../views/home/dashboard/servicedata/servicedata')
                },
                {
                    name: 'supplierdata',
                    path: '/supplierdata',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/dashboard/supplierdata/supplierdata'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/dashboard/supplierdata/supplierdata'))
                        // component: () =>
                        //     import ('../views/home/dashboard/supplierdata/supplierdata')
                },


                // 销售跟进
                {
                    name: 'neworder',
                    path: '/neworder',
                    meta: { keepAlive: true },
                    // component: resolve => require(['../views/home/order/neworder'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/order/neworder'))
                        // component: () =>
                        //     import ('../views/home/order/neworder')
                },
                {
                    name: 'orderfollowup',
                    path: '/orderfollowup',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/order/orderfollowup'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/order/orderfollowup'))
                        // component: () =>
                        //     import ('../views/home/order/orderfollowup')
                },

                // 设计跟进
                {
                    name: 'newdesign',
                    path: '/newdesign',
                    meta: { keepAlive: true },
                    // component: resolve => require(['../views/home/design/newdesign'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/design/newdesign'))
                        // component: () =>
                        //     import ('../views/home/design/newdesign')
                },
                {
                    name: 'designfollowup',
                    path: '/designfollowup',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/design/designfollowup'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/design/designfollowup'))
                        // component: () =>
                        //     import ('../views/home/design/designfollowup')
                },

                //生产跟进
                {
                    name: 'newsupplier',
                    path: '/newsupplier',
                    meta: { keepAlive: true },
                    // component: resolve => require(['../views/home/supplier/newsupplier'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/supplier/newsupplier'))
                        // component: () =>
                        //     import ('../views/home/supplier/newsupplier')
                },
                {
                    name: 'supplierfollowup',
                    path: '/supplierfollowup',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/supplier/supplierfollowup'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/supplier/supplierfollowup'))
                        // component: () =>
                        //     import ('../views/home/supplier/supplierfollowup')
                },
                {
                    name: 'suppdigitaldepartment',
                    path: '/suppdigitaldepartment',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/supplier/suppdigitaldepartment'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/supplier/suppdigitaldepartment'))
                        // component: () =>
                        //     import ('../views/home/supplier/suppdigitaldepartment')
                },

                //物流跟进
                {
                    name: 'logisticsfollowup',
                    path: '/logisticsfollowup',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/logistics/logisticsfollowup'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/logistics/logisticsfollowup'))
                        // component: () =>
                        //     import ('../views/home/logistics/logisticsfollowup')
                },

                // 财务管理
                {
                    name: 'finance',
                    path: '/finance',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/finance/finance'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/finance/finance'))
                        // component: () =>
                        //     import ('../views/home/finance/finance')
                },
                {
                    name: 'collection-reconciliation',
                    path: '/collection-reconciliation',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/finance/CollectionReconciliation'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/finance/CollectionReconciliation'))
                        // component: () =>
                        //     import ('../views/home/finance/CollectionReconciliation')
                },
                {
                    name: 'payment-reconciliation',
                    path: '/payment-reconciliation',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/finance/PaymentReconciliation'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/finance/PaymentReconciliation'))
                        // component: () =>
                        //     import ('../views/home/finance/PaymentReconciliation')
                },
                {
                    name: 'receivables-summary',
                    path: '/receivables-summary',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/finance/ReceivablesSummary'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/finance/ReceivablesSummary'))
                        // component: () =>
                        //     import ('../views/home/finance/ReceivablesSummary')
                },
                {
                    name: 'payable-summary',
                    path: '/payable-summary',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/finance/PayableSummary'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/finance/PayableSummary'))
                        // component: () =>
                        //     import ('../views/home/finance/PayableSummary')
                },
                {
                    name: 'fund-details',
                    path: '/fund-details',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/finance/FundDetails'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/finance/FundDetails'))
                        // component: () =>
                        //     import ('../views/home/finance/FundDetails')
                },
                {
                    name: 'income-expenditure',
                    path: '/income-expenditure',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/finance/IncomeExpenditure'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/finance/IncomeExpenditure'))
                        // component: () =>
                        //     import ('../views/home/finance/IncomeExpenditure')
                },
                {
                    name: 'achievements',
                    path: '/achievements',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/finance/Achievements'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/finance/Achievements'))
                        // component: () =>
                        //     import ('../views/home/finance/Achievements')
                },
                {
                    name: 'payslip',
                    path: '/payslip',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/finance/Payslip'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/finance/Payslip'))
                        // component: () =>
                        //     import ('../views/home/finance/Payslip')
                },
                {
                    name: 'financial-statements',
                    path: '/financial-statements',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/finance/FinancialStatements'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/finance/FinancialStatements'))
                        // component: () =>
                        //     import ('../views/home/finance/FinancialStatements')
                },
                {
                    name: 'account',
                    path: '/account',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/finance/Account'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/finance/Account'))
                        // component: () =>
                        //     import ('../views/home/finance/Account')
                },
                {
                    name: 'Invoicing',
                    path: '/Invoicing',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/finance/Invoicing'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/finance/Invoicing'))
                        // component: () =>
                        //     import ('../views/home/finance/Invoicing')
                },


                // 业务管理
                {
                    name: 'customer',
                    path: '/customer',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/business/customer/customer'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/business/customer/customer'))
                        // component: () =>
                        //     import ('../views/home/business/customer/customer'),
                },
                {
                    name: 'service',
                    path: '/service',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/business/service/service'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/business/service/service'))
                        // component: () =>
                        //     import ('../views/home/business/service/service')
                },
                {
                    name: 'supplier',
                    path: '/supplier',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/business/supplier/supplier'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/business/supplier/supplier'))
                        // component: () =>
                        //     import ('../views/home/business/supplier/supplier')
                },
                {
                    name: 'assistant',
                    path: '/assistant',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/business/businessAssistant/assistant'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/business/businessAssistant/assistant'))
                        // component: () =>
                        //     import ('../views/home/business/businessAssistant/assistant')
                },

                // 系统管理
                {
                    name: 'company-information',
                    path: '/company-information',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/system/CompanyInformation'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/system/CompanyInformation'))
                        // component: () =>
                        //     import ('../views/home/system/CompanyInformation'),
                },
                {
                    name: 'staff',
                    path: '/staff',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/system/Staff'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/system/Staff'))
                        // component: () =>
                        //     import ('../views/home/system/Staff'),
                },
                {
                    name: 'permission',
                    path: '/permission',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/system/Permission'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/system/Permission'))
                        // component: () =>
                        //     import ('../views/home/system/Permission'),
                },
                {
                    name: 'price-template',
                    path: '/price-template',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/system/PriceTemplate'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/system/PriceTemplate'))
                        // component: () =>
                        // import ('../views/home/system/PriceTemplate'),
                },
                {
                    name: 'face-sheet',
                    path: '/face-sheet',
                    meta: { keepAlive: false },
                    // component: resolve => require(['../views/home/system/FaceSheet'], resolve)
                    component: () => require.ensure([], (require) => require('../views/home/system/FaceSheet'))
                        // component: () =>
                        //     import ('../views/home/system/FaceSheet'),
                },
                // {
                //     name: 'custom-print',
                //     path: '/custom-print',
                //     meta: { keepAlive: false },
                //     component: () =>
                //         import ('../views/home/system/CustomPrint'),
                // },
            ]
        },
        {
            name: 'login',
            path: '/login',
            // component: resolve => require(['../views/login'], resolve)
            component: () => require.ensure([], (require) => require('../views/login'))
                // component: () =>
                //     import ('../views/login')
        },
        // {
        //     name: 'register',
        //     path: '/register',
        //     // component: resolve => require(['../views/register'], resolve)
        //     component: () => require.ensure([], (require) => require('../views/register'))
        //         // component: () =>
        //         //     import ('../views/register')
        // },

    ]
})

const reset = () => ({
    // mode: 'history', //require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: router
})

export function resetRouter() {
    const newRouter = reset()
    router.matcher = newRouter.matcher // reset router
}

export default router